import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Popup from '@techsoftware/happay-widgets/Popup';
import {
  deepClone,
  formatDate,
  shortenString,
  currencyFormatter,
} from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import Stepper from '@techsoftware/happay-widgets/Stepper';
import { hexToRgbColor } from '../../helpers/genericFormator';

export default class WorkFlowTrack extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopup: false,
    };
  }

  componentDidMount() {
    const { from } = this.props;
    const {
      data: {
        twf_id = '',
        object_data: { [from]: { invoice_id = '', vendor_id = '' } = {} } = {},
      } = {},
      getWorkflowComments,
    } = this.props;
    const params = {
      filter_type: 4,
      id: twf_id,
      object_id: from === 'vendor' ? vendor_id : invoice_id,
    };
    getWorkflowComments(params);
  }

  handleClick = () => {
    const { openPopup } = this.state;
    this.setState({
      openPopup: !openPopup,
    });
  };

  handleClose = event => {
    const eventID = event?.target?.id;
    if (!eventID.includes('generic-workflow-status')) {
      this.setState({
        openPopup: false,
      });
    }
  };

  requestorData = () => {
    const { data: { requestor: { name } = {}, created_on } = {} } = this.props;
    return (
      <Grid
        className="padding-l-10"
        container
        justify="space-between"
        alignItems="flex-start"
      >
        <div className="body dark">
          <div>Requested by</div>
          <div title={name} className="font-12 body">
            {shortenString(name, 24, 3)}
          </div>
        </div>
        <div className="font-12 body">
          {formatDate(created_on, 'DD MMM, YYYY, ')}
          {formatDate(created_on, 'h:mm A')}
        </div>
      </Grid>
    );
  };

  showComment = (id, amount = '', reason = '') => {
    const { comment = [] } = this.props;
    const currentComment = reason
      ? [{ comment: reason }]
      : comment.filter(el => el.twfs_ref === id) || [];
    if (currentComment.length || amount) {
      return (
        <>
          {currentComment.map((el, i) => (
            <div
              style={{ backgroundColor: '#e5f6f1' }}
              className="body padding-lr-16 padding-tb-8 margin-tb-6 border-radius-4"
            >
              {/* {amount && i === 0 ? (
                  <div className="margin-b-b">
                    <span className="fw-500 font-12">Approved Amount: </span>
                    <span className="font-12">{currencyFormatter(amount)}</span>
                  </div>
                ) : null} */}
              <span className="fw-500 font-12">Remark: </span>
              <span className="font-12">"{el?.comment}"</span>
            </div>
          ))}
        </>
      );
    }
    return null;
  };

  getStatus = name => {
    const { data: { is_blocked: isBlocked = false } = {} } = this.props;
    return isBlocked ? 'Request in process' : name;
  };

  formatStepperData = () => {
    const {
      data: {
        twf_states = [],
        is_completed = false,
        is_blocked: isBlocked,
        object_data: { [this.props.from]: { reason } = {} } = {},
      } = {},
    } = this.props;
    const reverseData = deepClone(twf_states).reverse();

    const sorttedData = reverseData.sort((a, b) => b.twfs_id - a.twfs_id);

    const contents = [];

    sorttedData.forEach((el, i) => {
      let content = null;
      const {
        action_taken_by = {},
        action_map = [],
        updated_on = '',
        pending_with_actors = [],
        state_setting_data: {
          container_status_details: { name, color_code, polarity } = {},
        } = {},
      } = el;

      const names = pending_with_actors.map(el => el.name).join(' / ');

      const show = Object.keys(el.action_map).length > 0;
      if (!show && !el.is_automatic) {
        const { approved_amount: amount } = el.action_map?.[0] || {};
        content = {
          content: (
            <>
              <Grid
                className="padding-l-10"
                container
                justify="space-between"
                alignItems="flex-start"
              >
                <div className="body dark">
                  <div>
                    {i !== 0 ? 'Action taken by' : this.getStatus(name)}
                  </div>
                  {!is_completed && (
                    <div title={names} className="font-12 body">
                      {shortenString(names, 24, 3)}
                    </div>
                  )}
                </div>
                <div className="font-12 body">
                  {formatDate(updated_on, 'DD MMM, YYYY, ')}
                  {formatDate(updated_on, 'h:mm A')}
                </div>
              </Grid>
              {this.showComment(el.twfs_id, amount, reason)}
            </>
          ),
        };
      } else if (!el.is_automatic) {
        const { approved_amount: amount } = el.action_map?.[0] || {};
        content = {
          content: (
            <>
              <Grid
                className="padding-l-10"
                container
                justify="space-between"
                alignItems="flex-start"
              >
                <div className="body dark">
                  <div>
                    {i !== 0
                      ? 'Action taken by'
                      : this.getStatus(action_map[0]?.action)}
                  </div>
                  <div title={action_taken_by.name} className="font-12 body">
                    {shortenString(action_taken_by.name, 24, 3)}
                  </div>
                </div>
                <div className="font-12 body">
                  {formatDate(updated_on, 'DD MMM, YYYY, ')}
                  {formatDate(updated_on, 'h:mm A')}
                </div>
              </Grid>
              {this.showComment(el.twfs_id, amount)}
            </>
          ),
        };
      }

      if (content) {
        contents.push({
          ...content,
          iconClass:
            polarity === 'negative' || show || is_completed ? '' : 'rotate-180',
          icon:
            polarity === 'negative'
              ? 'cross-fill'
              : show || is_completed
              ? 'tick-fill'
              : 'info-fill',
          color:
            polarity === 'negative'
              ? color_code
              : show || is_completed
              ? '#0aa778'
              : color_code,
          lineHeight: !el.action_taken_by.name && is_completed && '50px',
          lineColor:
            polarity === 'negative'
              ? color_code
              : show || is_completed
              ? '#0aa778'
              : color_code,
        });
      }
    });
    contents.push({
      content: this.requestorData(),
      icon: 'tick-fill',
      color: '#0aa778',
    });
    return contents;
  };

  drawStepperUI = () => (
    <Stepper
      type="vertical"
      data={this.formatStepperData()}
      stepperId="workflow-vertical-stepper"
      iconSize="small"
    />
  );

  render() {
    const { openPopup } = this.state;
    const {
      data: {
        is_blocked: isBlocked,
        object_data: {
          [this.props.from]: {
            approval_status: { name, color_code } = {},
          } = {},
        } = {},
      } = {},
      from,
    } = this.props;
    return (
      <Grid
        style={{ width: '225px', float: 'right' }}
        className="pos-relative margin-b-24"
      >
        <Grid
          container
          id="generic-workflow-status"
          justify="space-between"
          style={{
            border: `1px solid ${color_code}`,
            color: color_code,
            background: `rgb(${hexToRgbColor(color_code)}, 0.1`,
          }}
          className="padding-lr-14 padding-tb-8 border-radius-4 pointer"
          onClick={this.handleClick}
        >
          <span
            id="generic-workflow-status-text"
            className="fw-500 user-select-none"
          >
            {this.getStatus(name)}
          </span>
          <Icons
            id="generic-workflow-status-icon"
            type={openPopup ? 'dropup' : 'dropdown'}
          />
        </Grid>
        <Popup
          id="generic-workflow-popup"
          parentElementId="generic-workflow-status"
          open={openPopup}
          pointerPlacement="top-right"
          variant="scroll"
          popupStyle={{ left: '-100px', top: '3px' }}
          onClose={this.handleClose}
        >
          <div
            style={{ width: '320px', maxHeight: '400px', overflow: 'auto' }}
            className="padding-lr-16 padding-tb-30"
          >
            {this.drawStepperUI()}
          </div>
        </Popup>
      </Grid>
    );
  }
}
